import "core-js/modules/es.array.reverse.js";
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _class2, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _dec1, _dec10, _dec11, _class3, _descriptor1, _descriptor10, _descriptor11, _dec12, _dec13, _dec14, _class4, _descriptor12, _descriptor13, _descriptor14, _dec15, _dec16, _class5, _descriptor15, _descriptor16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _class6, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _class7, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectTrait from "../Decorators/objectTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import AttributionTraits from "./AttributionTraits";
import { FeatureInfoTemplateTraits } from "./FeatureInfoTraits";
export let RectangleTraits = (_dec = primitiveTrait({
  type: "number",
  name: "West",
  description: "The westernmost longitude in degrees."
}), _dec2 = primitiveTrait({
  type: "number",
  name: "South",
  description: "The southernmost longitude in degrees."
}), _dec3 = primitiveTrait({
  type: "number",
  name: "East",
  description: "The easternmost longitude in degrees."
}), _dec4 = primitiveTrait({
  type: "number",
  name: "North",
  description: "The northernmost longitude in degrees."
}), _class = class RectangleTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "west", _descriptor, this);
    _initializerDefineProperty(this, "south", _descriptor2, this);
    _initializerDefineProperty(this, "east", _descriptor3, this);
    _initializerDefineProperty(this, "north", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "west", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "south", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "east", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "north", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export let LookAtTraits = (_dec5 = primitiveTrait({
  type: "number",
  name: "Target longitude",
  description: "Target longitude on the WGS84 ellipsoid in degrees"
}), _dec6 = primitiveTrait({
  type: "number",
  name: "Target latitude",
  description: "Target latitude on the WGS84 ellipsoid in degrees"
}), _dec7 = primitiveTrait({
  type: "number",
  name: "Target height",
  description: "Target height in meters. Treat it as camera height. A positive value is above the WGS84 ellipsoid. Default to 100 meters."
}), _dec8 = primitiveTrait({
  type: "number",
  name: "Heading",
  description: "Heading in degrees. Treat it as camera bearing. North is 0. A positive value rotates clockwise, negative anti-clockwise. Default to 0."
}), _dec9 = primitiveTrait({
  type: "number",
  name: "Pitch",
  description: "Pitch in degrees. Treat it as camera pitch. A positive value is to look down, negative up. Default to 45."
}), _dec0 = primitiveTrait({
  type: "number",
  name: "Range",
  description: "The range in meters. It is the distance between the target position and camera position projected onto the local plane. Not negative and default to 500."
}), _class2 = class LookAtTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "targetLongitude", _descriptor5, this);
    _initializerDefineProperty(this, "targetLatitude", _descriptor6, this);
    _initializerDefineProperty(this, "targetHeight", _descriptor7, this);
    _initializerDefineProperty(this, "heading", _descriptor8, this);
    _initializerDefineProperty(this, "pitch", _descriptor9, this);
    _initializerDefineProperty(this, "range", _descriptor0, this);
  }
}, _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "targetLongitude", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "targetLatitude", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "targetHeight", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 100;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "heading", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "pitch", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 45;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "range", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 500;
  }
}), _class2);
export let VectorTraits = (_dec1 = primitiveTrait({
  type: "number",
  name: "x",
  description: "X component of vector in the Earth-centered Fixed frame."
}), _dec10 = primitiveTrait({
  type: "number",
  name: "y",
  description: "Y component of vector in the Earth-centered Fixed frame."
}), _dec11 = primitiveTrait({
  type: "number",
  name: "z",
  description: "Z component of vector in the Earth-centered Fixed frame."
}), _class3 = class VectorTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "x", _descriptor1, this);
    _initializerDefineProperty(this, "y", _descriptor10, this);
    _initializerDefineProperty(this, "z", _descriptor11, this);
  }
}, _descriptor1 = _applyDecoratedDescriptor(_class3.prototype, "x", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class3.prototype, "y", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class3.prototype, "z", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3);
export let CameraTraits = (_dec12 = objectTrait({
  type: VectorTraits,
  name: "position",
  description: "Position of the camera in the Earth-centered Fixed frame in meters."
}), _dec13 = objectTrait({
  type: VectorTraits,
  name: "direction",
  description: "The look direction of the camera in the Earth-centered Fixed frame."
}), _dec14 = objectTrait({
  type: VectorTraits,
  name: "up",
  description: "The up vector direction of the camera in the Earth-centered Fixed frame."
}), _class4 = class CameraTraits extends RectangleTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "position", _descriptor12, this);
    _initializerDefineProperty(this, "direction", _descriptor13, this);
    _initializerDefineProperty(this, "up", _descriptor14, this);
  }
}, _descriptor12 = _applyDecoratedDescriptor(_class4.prototype, "position", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class4.prototype, "direction", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class4.prototype, "up", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class4);
export let IdealZoomTraits = (_dec15 = objectTrait({
  type: LookAtTraits,
  name: "Look at",
  description: "Parameters for camera to look at a target."
}), _dec16 = objectTrait({
  type: CameraTraits,
  name: "Camera",
  description: "Use camera position, direction and up if fully defined. Otherwise use rectangle if fully defined."
}), _class5 = class IdealZoomTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "lookAt", _descriptor15, this);
    _initializerDefineProperty(this, "camera", _descriptor16, this);
  }
}, _descriptor15 = _applyDecoratedDescriptor(_class5.prototype, "lookAt", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class5.prototype, "camera", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class5);
export let InitialMessageTraits = (_dec17 = primitiveTrait({
  type: "string",
  name: "Title",
  description: "The title of the message."
}), _dec18 = primitiveTrait({
  type: "string",
  name: "Content",
  description: "The content of the message."
}), _dec19 = primitiveTrait({
  type: "string",
  name: "Key",
  description: "Identifier. If multiple messages with the same key are triggered, only the first will be displayed."
}), _dec20 = primitiveTrait({
  type: "boolean",
  name: "Confirmation",
  description: "Whether the message requires confirmation."
}), _dec21 = primitiveTrait({
  type: "string",
  name: "Name",
  description: "If `confirmation` is true, the text to put on the confirmation button."
}), _dec22 = primitiveTrait({
  type: "number",
  name: "Width",
  description: "Width of the message."
}), _dec23 = primitiveTrait({
  type: "number",
  name: "height",
  description: "Height of the message."
}), _dec24 = primitiveTrait({
  type: "boolean",
  name: "Show as toast message",
  description: "Show the initial message as a toast"
}), _dec25 = primitiveTrait({
  type: "number",
  name: "Toast visible duration",
  description: "Time in seconds after which the toast will be dismissed. If undefined, user must take action."
}), _class6 = class InitialMessageTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "title", _descriptor17, this);
    _initializerDefineProperty(this, "content", _descriptor18, this);
    _initializerDefineProperty(this, "key", _descriptor19, this);
    _initializerDefineProperty(this, "confirmation", _descriptor20, this);
    _initializerDefineProperty(this, "confirmText", _descriptor21, this);
    _initializerDefineProperty(this, "width", _descriptor22, this);
    _initializerDefineProperty(this, "height", _descriptor23, this);
    _initializerDefineProperty(this, "showAsToast", _descriptor24, this);
    _initializerDefineProperty(this, "toastVisibleDuration", _descriptor25, this);
  }
}, _descriptor17 = _applyDecoratedDescriptor(_class6.prototype, "title", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class6.prototype, "content", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class6.prototype, "key", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class6.prototype, "confirmation", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class6.prototype, "confirmText", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class6.prototype, "width", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class6.prototype, "height", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class6.prototype, "showAsToast", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class6.prototype, "toastVisibleDuration", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class6);

/* eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging */
let MappableTraits = (_dec26 = objectTrait({
  type: RectangleTraits,
  name: "Rectangle",
  description: "The bounding box rectangle that contains all the data in this catalog item."
}), _dec27 = objectTrait({
  type: IdealZoomTraits,
  name: "Ideal zoom",
  description: "Override default ideal zoom if the given values are valid."
}), _dec28 = primitiveTrait({
  type: "boolean",
  name: "Disable Preview",
  description: "Disables the preview on the Add Data panel. This is useful when the preview will be very slow to load."
}), _dec29 = primitiveTrait({
  type: "boolean",
  name: "Disable zoom to",
  description: "Disables the zoom to (aka 'Ideal Zoom') button in the workbench."
}), _dec30 = primitiveTrait({
  type: "boolean",
  name: "Zoom on enable",
  description: "Zoom to dataset when added to workbench. Doesn't work if `disableZoomTo` is true."
}), _dec31 = primitiveTrait({
  type: "boolean",
  name: "Show",
  description: "Show or hide a workbench item. When show is false, a mappable item is removed from the map and a chartable item is removed from the chart panel."
}), _dec32 = objectTrait({
  name: "Initial message",
  type: InitialMessageTraits,
  description: "A message to show when the user adds the catalog item to the workbench. Useful for showing disclaimers."
}), _dec33 = objectTrait({
  type: FeatureInfoTemplateTraits,
  name: "Feature info template",
  description: "A template object for formatting content in feature info panel"
}), _dec34 = primitiveTrait({
  type: "string",
  name: "Show string if (feature info) property value is null",
  description: "If the value of a property is null or undefined, show the specified string as the value of the property. Otherwise, the property name will not be listed at all."
}), _dec35 = primitiveTrait({
  type: "number",
  name: "Maximum shown feature infos",
  description: 'The maximum number of "feature infos" that can be displayed in feature info panel.'
}), _dec36 = primitiveTrait({
  type: "string",
  name: "Preferred viewer mode",
  description: "The preferred viewer mode for this item - either '2d' '3d' or '3dsmooth'. If this dataset is used as a basemap then we automatically switch the viewer to the preferred mode. However the user can still switch to another mode, so this preference is not strongly enforced."
}), _class7 = class MappableTraits extends mixTraits(AttributionTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "rectangle", _descriptor26, this);
    _initializerDefineProperty(this, "idealZoom", _descriptor27, this);
    _initializerDefineProperty(this, "disablePreview", _descriptor28, this);
    _initializerDefineProperty(this, "zoomOnAddToWorkbench", _descriptor29, this);
    _initializerDefineProperty(this, "show", _descriptor30, this);
    _initializerDefineProperty(this, "initialMessage", _descriptor31, this);
    _initializerDefineProperty(this, "featureInfoTemplate", _descriptor32, this);
    _initializerDefineProperty(this, "showStringIfPropertyValueIsNull", _descriptor33, this);
    _initializerDefineProperty(this, "maximumShownFeatureInfos", _descriptor34, this);
    _initializerDefineProperty(this, "preferredViewerMode", _descriptor35, this);
  }
  get disableZoomTo() {
    return false;
  }
}, _descriptor26 = _applyDecoratedDescriptor(_class7.prototype, "rectangle", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class7.prototype, "idealZoom", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class7.prototype, "disablePreview", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class7.prototype, "disableZoomTo", [_dec29], Object.getOwnPropertyDescriptor(_class7.prototype, "disableZoomTo"), _class7.prototype), _descriptor29 = _applyDecoratedDescriptor(_class7.prototype, "zoomOnAddToWorkbench", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class7.prototype, "show", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class7.prototype, "initialMessage", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class7.prototype, "featureInfoTemplate", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class7.prototype, "showStringIfPropertyValueIsNull", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class7.prototype, "maximumShownFeatureInfos", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class7.prototype, "preferredViewerMode", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class7);
/* eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging */
export default MappableTraits;